import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { NavBar } from 'components/NavBar/NavBar'
import { NoData } from 'components/NoData'
import { Button } from 'components/ui/Button/Button'
import { Flex, PageWrapper } from 'styling/GlobalStyles'
import { OtherText } from 'styling/Typography'
import { useOpsBootstrap } from 'hooks/useOpsBootstrap'
import { USE_OPS_MOCKS } from '../Shared/opsControl'
import { DemoBadge } from '../Shared/OpsSharedComponents'
import { deptByKey } from '../Shared/opsDepartments'
import { EnvironStrip } from './EnvironStrip'
import { TodayQuestionCard } from './TodayQuestionCard'
import { TodayInbox } from './TodayInbox'
import { TodaySwitcher } from './TodaySwitcher'
import { RaiseRequestModal } from './RaiseRequestModal'
import { RequestsSentByDept, RequestsToDept } from './TodayRequests'
import { buildDeptCards, deptInboxItems } from './todayData'
import { QuestionsGrid, TodayTitle } from './OpsToday.styled'

export const DeptToday = () => {
  const { deptKey } = useParams()
  const profiles = useSelector((s: RootState) => s.deptOpsProfiles.profiles)
  const isLoadingProfiles = useSelector((s: RootState) => s.deptOpsProfiles.isLoading)
  const dept = deptByKey(deptKey || '', profiles)
  const [raiseOpen, setRaiseOpen] = useState(false)
  useOpsBootstrap()

  if (isLoadingProfiles && !profiles.length) {
    return (
      <>
        <NavBar />
        <PageWrapper>
          <TodayTitle>Today</TodayTitle>
          <NoData text='Loading department profiles…' />
        </PageWrapper>
      </>
    )
  }

  if (!dept) {
    return (
      <>
        <NavBar />
        <PageWrapper>
          <TodayTitle>Today</TodayTitle>
          <TodaySwitcher activeKey={deptKey || ''} />
          <NoData text='This department is not set up yet.' />
        </PageWrapper>
      </>
    )
  }

  const cards = USE_OPS_MOCKS ? buildDeptCards(dept) : []

  return (
    <>
      <NavBar />
      <PageWrapper>
        <Flex between center width='100%'>
          <Flex center gap='0.75rem'>
            <TodayTitle>{dept.name}</TodayTitle>
            <DemoBadge />
          </Flex>
          <Button variant='primary' onClick={() => setRaiseOpen(true)}>
            Raise request
          </Button>
        </Flex>
        <OtherText grey>Day Shift · 06:00–18:00</OtherText>
        <TodaySwitcher activeKey={dept.key} />
        <EnvironStrip />
        {cards.length > 0 && (
          <QuestionsGrid>
            {cards.map((card) => (
              <TodayQuestionCard key={card.id} card={card} />
            ))}
          </QuestionsGrid>
        )}
        <RequestsToDept dept={dept} />
        {USE_OPS_MOCKS && <TodayInbox key={dept.key} initialItems={deptInboxItems(dept.key)} />}
        <RequestsSentByDept dept={dept} />
        {raiseOpen && <RaiseRequestModal dept={dept} closeModal={() => setRaiseOpen(false)} />}
      </PageWrapper>
    </>
  )
}
